import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * Skeleton loader shadcn classique. Affiche une zone gris-anime
 * en attendant qu'une donnee soit prete. Conserve le layout pour eviter le CLS.
 *
 * Usage :
 *   <Skeleton className="h-12 w-full" />
 *   <Skeleton className="h-4 w-32 rounded-full" />
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted/60', className)}
      aria-hidden="true"
      {...props}
    />
  );
}
